import script from "./FirstStart.vue?vue&type=script&setup=true&lang=ts"
export * from "./FirstStart.vue?vue&type=script&setup=true&lang=ts"

import "./FirstStart.vue?vue&type=style&index=0&id=496201f2&lang=scss&scoped=true"
import "../styles/native-auth.css?vue&type=style&index=1&id=496201f2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496201f2"]])

export default __exports__